export default __webpack_public_path__ + "static/media/step-3.070bae01.070bae01.jpg";